import { Injectable } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { AssignmentTrigger, AssignmentWithData } from "../../checklists/checklist.interface";
import { AssignmentDefinition, AssignmentSolutionData, AssignmentSourceContext, ManifestAssignment } from "../assignment.interface";
import { OverlayEventDetail } from "@ionic/core";
import { AssignmentModalComponent } from "./assignment-modal.component";
import { RideOpsUiService } from "source/app/configuration/services/rideops-ui.service";

@Injectable()
export class AssignmentModalService {
	constructor(
		private modalController: ModalController,
		private rideOpsUi: RideOpsUiService,
	) {}

	open = async (
		assignment: ManifestAssignment,
		definition: AssignmentDefinition,
		trigger: AssignmentTrigger = null,
		solution: AssignmentSolutionData = null,
		sourceContext: AssignmentSourceContext = null,
	): Promise<AssignmentWithData> => {
		const assignmentModal = await this.modalController.create({
			component: AssignmentModalComponent,
			componentProps: {
				assignment: assignment,
				definition: definition,
				trigger: trigger,
				solution: solution,
				sourceContext: sourceContext,
			},
			id: AssignmentModalComponent.modalId,
			cssClass: this.rideOpsUi.isV2Active() ? "assignment-modal assignment-modal-v2" : "assignment-modal",
			showBackdrop: true,
			backdropDismiss: true,
		});

		await assignmentModal.present();
		const result: OverlayEventDetail<AssignmentWithData> = await assignmentModal.onDidDismiss();
		return result.data;
	};
}
